<template>
  <div class="calendar_header">
    <calendar-header-day day="Sunday" :is-weekend="true" />
    <calendar-header-day day="Monday" :is-weekend="false" />
    <calendar-header-day day="Tuesday" :is-weekend="false" />
    <calendar-header-day day="Wednesday" :is-weekend="false" />
    <calendar-header-day day="Thursday" :is-weekend="false" />
    <calendar-header-day day="Friday" :is-weekend="false" />
    <calendar-header-day day="Saturday" :is-weekend="true" />
  </div>
</template>

<script>
import CalendarHeaderDay from './calendar-header-day';

export default {
  components: { CalendarHeaderDay },
};
</script>
